(ns practitest.frontend.forms3.link-to-external-modal.subs
  (:require
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::link-to-external-modal
  (fn [db [_]]
    (:link-to-external-modal db)))

(re-frame/reg-sub
  ::show-link-to-external-modal?
  :<- [::link-to-external-modal]
  (fn [link-to-external-modal [_]]
    (:show-link-to-external-modal? link-to-external-modal)))

(re-frame/reg-sub
  ::get-link-to-external-modal-text-field-value
  :<- [::link-to-external-modal]
  (fn [link-to-external-modal [_ field-id]]
    (get-in link-to-external-modal [:fields field-id :value])))

(re-frame/reg-sub
  ::get-link-to-external-modal-notifications
  :<- [::link-to-external-modal]
  (fn [link-to-external-modal [_]]
    (:link-to-external-modal-notifications link-to-external-modal)))
